var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn reports" },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "bg-white", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "p-0",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [_c("h5", [_vm._v(" Forms Report")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1.5" } },
                            [
                              _c("h6", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("COMMON.DATE_RANGE")) +
                                    " "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  range: "",
                                  lang: "en",
                                  format: "YYYY-MM-DD",
                                  "append-to-body": "",
                                  clearable: false,
                                  width: "220px"
                                },
                                model: {
                                  value: _vm.formsDateRange,
                                  callback: function($$v) {
                                    _vm.formsDateRange = $$v
                                  },
                                  expression: "formsDateRange"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1" } },
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.fetchFormStatusReports } },
                                [_vm._v("Fetch")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/process/processed" }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "dash-box",
                                          attrs: { "no-body": "" }
                                        },
                                        [
                                          _c(
                                            "b-card-body",
                                            { staticClass: "pb-6" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "dash-row" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "10" } },
                                                    [
                                                      _c(
                                                        "h1",
                                                        { staticClass: "mb-0" },
                                                        [
                                                          _vm._v(
                                                            "Processed Forms"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "process-datas"
                                                        },
                                                        _vm._l(
                                                          _vm.processedFormsCounts,
                                                          function(
                                                            count,
                                                            processed
                                                          ) {
                                                            return _c("div", [
                                                              _vm.processedFormsStatus.includes(
                                                                processed
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "process-data"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h4",
                                                                        {
                                                                          class:
                                                                            "processed-" +
                                                                            processed
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "animated-number",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  count ||
                                                                                  0,
                                                                                formatValue:
                                                                                  _vm.formatNumber,
                                                                                duration: 1500
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "h3",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "COMMON." +
                                                                                    processed.toUpperCase()
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          }
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "2" } },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.svg.forms
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/process/processed" }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "dash-box",
                                          attrs: { "no-body": "" }
                                        },
                                        [
                                          _c(
                                            "b-card-body",
                                            { staticClass: "pb-6" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "dash-row" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "10" } },
                                                    [
                                                      _c(
                                                        "h1",
                                                        { staticClass: "mb-0" },
                                                        [_vm._v("Triage Forms")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "process-datas"
                                                        },
                                                        _vm._l(
                                                          _vm.triageFormsCounts,
                                                          function(
                                                            count,
                                                            processed
                                                          ) {
                                                            return _c("div", [
                                                              _vm.triagedFormsStatus.includes(
                                                                processed
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "process-data"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h4",
                                                                        {
                                                                          class:
                                                                            "processed-" +
                                                                            processed
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "animated-number",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  count ||
                                                                                  0,
                                                                                formatValue:
                                                                                  _vm.formatNumber,
                                                                                duration: 1500
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "h3",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "COMMON." +
                                                                                    processed.toUpperCase()
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          }
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "2" } },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.svg.forms
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/process/processed" }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "dash-box",
                                          attrs: { "no-body": "" }
                                        },
                                        [
                                          _c(
                                            "b-card-body",
                                            { staticClass: "pb-6" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "dash-row" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "10" } },
                                                    [
                                                      _c(
                                                        "h1",
                                                        { staticClass: "mb-0" },
                                                        [
                                                          _vm._v(
                                                            "Unmatched Forms"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "process-datas"
                                                        },
                                                        _vm._l(
                                                          _vm.unmatchedFormsCounts,
                                                          function(
                                                            count,
                                                            processed
                                                          ) {
                                                            return _c("div", [
                                                              _vm.unmatchedFormsStatus.includes(
                                                                processed
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "process-data"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h4",
                                                                        {
                                                                          class:
                                                                            "processed-" +
                                                                            processed
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "animated-number",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  count ||
                                                                                  0,
                                                                                formatValue:
                                                                                  _vm.formatNumber,
                                                                                duration: 1500
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "h3",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "COMMON." +
                                                                                    processed.toUpperCase()
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          }
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "2" } },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.svg.forms
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/process/processed" }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card",
                                        {
                                          staticClass: "dash-box",
                                          attrs: { "no-body": "" }
                                        },
                                        [
                                          _c(
                                            "b-card-body",
                                            { staticClass: "pb-6" },
                                            [
                                              _c(
                                                "b-row",
                                                { staticClass: "dash-row" },
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "10" } },
                                                    [
                                                      _c(
                                                        "h1",
                                                        { staticClass: "mb-0" },
                                                        [_vm._v("ESF Triaging")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "process-datas"
                                                        },
                                                        _vm._l(
                                                          _vm.esfTriageFormsCounts,
                                                          function(
                                                            count,
                                                            processed
                                                          ) {
                                                            return _c("div", [
                                                              _vm.esfTriageFormsStatus.includes(
                                                                processed
                                                              )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "process-data"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "h4",
                                                                        {
                                                                          class:
                                                                            "processed-" +
                                                                            processed
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "animated-number",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  count ||
                                                                                  0,
                                                                                formatValue:
                                                                                  _vm.formatNumber,
                                                                                duration: 1500
                                                                              }
                                                                            }
                                                                          )
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "h3",
                                                                        {},
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "COMMON." +
                                                                                    processed.toUpperCase()
                                                                                )
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          }
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { cols: "2" } },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.svg.forms
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "recent-forms" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "received-form",
                  attrs: { "no-body": "", "bg-variant": "light" }
                },
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "p-0",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "3" } },
                        [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("ANALYTICS.FORMS_INSIGHTS")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "1.5" } },
                        [
                          _c("h6", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("COMMON.DATE_RANGE")) + " "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "4" } },
                        [
                          _c("date-picker", {
                            attrs: {
                              range: "",
                              lang: "en",
                              format: "YYYY-MM-DD",
                              "append-to-body": "",
                              clearable: false,
                              width: "220px"
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "1" } },
                        [
                          _c(
                            "b-button",
                            { on: { click: _vm.fetchProcessedForms } },
                            [_vm._v("Fetch")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { sm: "2" } },
                        [
                          _c(
                            "b-button",
                            { on: { click: _vm.downloadFormsInsights } },
                            [_vm._v("Download")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "report-table" },
                    [
                      _vm.showProcessedForms
                        ? _c("b-table", {
                            attrs: {
                              "show-empty": "",
                              striped: "",
                              "empty-text": _vm.$t("COMMON.NO_RECORD"),
                              hover: "",
                              responsive: "sm",
                              variant: "danger",
                              items: _vm.dailyReports,
                              fields: _vm.tableFields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc
                            },
                            on: {
                              "update:sortBy": function($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function($event) {
                                _vm.sortDesc = $event
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "HEAD_title",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_username",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_total_page_count",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_average_confidence",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_total_fields",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_transcribed_fields",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_accuracy_percentage",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_edited_fields",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_status",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_created_at",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_updated_at",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_document_recieved_at",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "HEAD_time_difference",
                                fn: function(data) {
                                  return [
                                    _c("em", [
                                      _vm._v(_vm._s(_vm.$t(data.label)))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        : _c(
                            "content-placeholders",
                            [
                              _c("content-placeholders-text", {
                                attrs: { lines: 12 }
                              })
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "infinite-loading",
                        {
                          ref: "infiniteLoading",
                          attrs: { distance: _vm.distance, spinner: "spiral" },
                          on: { infinite: _vm.dailyReportsInfinetHandler }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "no-more" },
                            slot: "no-more"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            attrs: { slot: "no-results" },
                            slot: "no-results"
                          })
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8445ba0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8445ba0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/reports/formsInsights.vue
// module id = 1257
// module chunks = 2